import CloseIcon from "@mui/icons-material/Close";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import Button from "@mui/material/Button";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import type { CSSProperties, FC } from "react";
import { FloatingActionBar } from "src/components/FloatingActionBar/FloatingActionBar";
import theme from "src/styles/theme";
import css from "./SunsetStoreActionBar.module.css";

const buttonStyles: CSSProperties = { textTransform: "none", paddingInline: "1rem" };

export interface SunsetStoreActionBarProps {
  active: boolean;
  count: number;
  onClear: () => void;
  onSelectAll: () => void;
  onConfirm: () => void;
}

export const SunsetStoreActionBar: FC<SunsetStoreActionBarProps> = ({
  active,
  count,
  onConfirm,
  onClear,
  onSelectAll,
}) => (
  <ThemeProvider theme={theme}>
    <FloatingActionBar active={active} className={css.sunsetStoreActionBar}>
      <div>
        <span>
          {count} {count === 1 ? <>store</> : <>stores</>} marked for sunsetting
        </span>
      </div>
      <div className={css.buttons}>
        <Button
          startIcon={<CloseIcon />}
          style={buttonStyles}
          variant="outlined"
          onClick={() => onClear()}
          disabled={!active}
        >
          Cancel
        </Button>
        <Button
          startIcon={<SelectAllIcon />}
          style={buttonStyles}
          variant="outlined"
          onClick={() => onSelectAll()}
          disabled={!active}
        >
          Select All
        </Button>
        <Button style={buttonStyles} variant="contained" color="primary" onClick={() => onConfirm()} disabled={!active}>
          Confirm Sunsetting
        </Button>
      </div>
    </FloatingActionBar>
  </ThemeProvider>
);
